export enum ClaimType {
  VERIFY = "verify", // 验证,关联账号
  MODEL = "model", // 模型选择
  RESULT = "result", // 认领结果
}

export enum ClaimResultType {
  SUCCESS = "success", // 认领成功
  PARTIAL_SUCCESS = "partial_success", // 部分成功
  FAIL = "fail", // 认领失败
}

export enum ClaimErrorCode {
  // 获取第三方用户信息失败
  THIRD_PARTY_USER_INFO_FAIL = 1004000039,
  // 认领模型失败
  CLAIM_MODEL_FAIL = 1004000040,
  // 不支持该类型
  NOT_SUPPORT_TYPE = 1004000041,
  // 一个用户一次只能认领一个用户
  ONE_USER_ONLY = 1004000042,
  // 未经过验证，禁止认领
  NOT_VERIFIED = 1004000043,
  //  认领模型类型不符合
  MODEL_BEEN_CLAIMED = 1004000047,
  // 关联账号超过10个
  ACCOUNT_LIMIT = 1003002032,
}
